enum LayoutEnum {
  BASE_LAYOUT,
  LANDING_PAGE_LAYOUT,
}

export default LayoutEnum;
